const HistoryPage = () => {
  return (
    <div className="container">
      <h1>Historique</h1>
    </div>
  );
};

export default HistoryPage;